import { IProductInsuranceState, ISetProductInsuranceAction } from "./types";
import ActionTypes from '../../../../constants/ActionTypes';

const initialState: IProductInsuranceState = {
  hisPolicies: [],
  numberPriceRate: 24,
  selectedInsurance: null,
};
const productInsuranceReducer = (
  state = initialState,
  action: ISetProductInsuranceAction,
): IProductInsuranceState => {
  switch (action.type) {
  case ActionTypes.PRODUCT.SET_PRODUCT_INSURANCE:
    return {
      ...state,
      hisPolicies: action.payload.hisPolicies,
      numberPriceRate: action.payload.numberPriceRate,
    };
  case ActionTypes.PRODUCT.SET_SELECTED_INSURANCE:
    const selectedInsurance = action.payload ? { policyId: action.payload.id, price: action.payload.price } : null;
    return {
      ...state,
      selectedInsurance: selectedInsurance,
    };
  case ActionTypes.PRODUCT.CLEAR_SELECTED_INSURANCE:
    return {
      ...state,
      selectedInsurance: null,
    };
  }
  return state;
};

export default productInsuranceReducer;
